import React from 'react';
import PropTypes from 'prop-types';

function ChevronInactive({ size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.66675 6L8.00008 11.3333L13.3334 6" stroke="#88898B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

ChevronInactive.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
}

export default ChevronInactive;
